import React, { ChangeEvent, ReactNode } from 'react';
import { connect } from 'react-redux';
import { AppState, IPageState } from './../appredux';
import { ThemeProvider, withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, FormControl, Select, MenuItem, TextField } from '@material-ui/core';
import ResponsiveImgMaterialUi from 'responsive-img-material-ui';
import theme from './../themes';



interface DialogProps extends WithStyles<typeof styles> {
    page: IPageState,
}

interface DialogState {
    open: boolean
}

class DialogUkryjPracownika extends React.Component<DialogProps, DialogState>  {
    stylInputaIlePokoi: React.CSSProperties = { padding: "6px 14px", textAlign: "left", fontSize: "15px" };

    constructor(props: DialogProps) {
        super(props, {});
        this.state = {
            open: false
        }
    }

    componentDidUpdate(prevProps: DialogProps) {
        if(this.props.page.openInfo !== prevProps.page.openInfo){
           this.setState({ open: true})
        }
    }

   close = () => {
    this.setState({ open: false}) 
   }

    render() {
        const classes = this.props.classes;

        return (
            <>
                <Dialog
                    maxWidth="xs"
                    open={this.state.open}
                    onEscapeKeyDown={this.close}
                    onBackdropClick={this.close}
                    fullWidth
                >
                    <DialogTitle disableTypography style={{padding: "16px 24px 0px 24px"}}>
                        <Typography gutterBottom variant="h6" component="h2" color='primary'
                            className={`${classes.headline}`}><b style={{ }}>{"info"}</b>
                        </Typography>
                        <hr style={{ marginTop: "10px", borderBottom: "0px" }} />
                    </DialogTitle>
                    <DialogContent>

                    <DialogContentText className={`${classes.dialogContentText} ${classes.gray}`} style={{color: "#555"}}>
                            {"Więcej informacji po zalogowaniu"}
                        </DialogContentText> 

                       
                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" color="primary" size="small" className={classes.button}
                            onClick={this.close}>
                            <b>wróć</b>
                        </Button>
                    </DialogActions>
                </Dialog>
            </>

        );
    }
}

const styles = (theme: Theme) => ({
    primary: {
        color: theme.palette.primary.main
      },
      secondary: {
        color: theme.palette.secondary.main
      },
      error: {
          color: "rgb(244, 67, 54)"
      },
      paddingBottom0: {
        paddingBottom: 0
      },
      paddingLeft: {
        paddingLeft: "20px"
      },
      headline: {
        lineHeight: "20px",
      },
      dialogContentText: {
        color: theme.palette.text.secondary,
        whiteSpace: "pre" as "pre",
        minHeight: "12px",
        marginBottom: '12px'
      },
      button: {
        textTransform: "none" as "none"
    },

    label: {
        //color: theme.palette.primary.main,
        //color: theme.palette.text.secondary,
        //fontFamilly: "sans-serif",
        //fontSize: "small"
        fontSize: "13px",
        fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
        lineHeight: "20px",
        fontWeight: "bold" as "bold", 
        //fontWeight: theme.typography.body2.fontWeight,
        //paddingLeft: "20px",
        //padding: "7px 0 4px",
        marginRight: "10px",
        width: "110px",
       // width: "calc(100% + -85px)",
        display: "inline-block" as "inline-block",
        //"@media (max-width: 600px)": {
        //  width: "90px",
        //}

      },
     labelColor: {
        //color: theme.palette.text.secondary,
        color: theme.palette.primary.main,
      },
      formControl: {
        //display: "block",
        //paddingBottom: "35px"
        marginTop: "0px", //4px
        
        //display: "inline-flex" as "inline-flex",
        //display: "flex" as "flex",
        //alignItems: "center" as "center",
        //flexDirection: "row" as "row",   
    },
    menuItem: {
        fontSize: "15px !important"  
      },
      select: {
        //color: "rgb(0, 0, 0)",
        color: theme.palette.primary.main,
        //color: orangeTheme.palette.primary.main,
        //color: 'seagreen',
        padding: "8px 14px", fontSize: "15px", 
        //padding: "8px 14px",
        //fontSize: '16px',
        float: "left" as "left",
        textAlign: "left" as "left",
        //fontWeight: "normal" as "normal", 
        //fontWeight: "bold" as "bold", 
        //width: "120px"
        //width: "clac(100% + - 164px)"
        
      },
      inputWidth: {
        //width: "15%",
        width: "100%",
        marginBottom: "12px"
        //display: "inline-flex" as "inline-flex",
        //"@media (max-width: 600px)": {
        //  width: 'calc(100% + -100px)', 
        //}
      },
      textField: {
        //color: "rgb(0, 0, 0)",
        //color: theme.palette.primary.main,
        color: theme.palette.primary.main,
        //color: 'seagreen',
        padding: "8px 14px",
        fontSize: '16px',
        float: "left" as "left",
        textAlign: "left" as "left",
        fontWeight: "normal" as "normal", 
        //width: "120px"
        
      },
      gray: {
        color: theme.palette.text.secondary,
      },
});

const mapStateToProps = (state: AppState) => ({
    page: state.pageState,
});

export default connect(mapStateToProps)(withStyles(styles)(DialogUkryjPracownika));

